module.exports = __webpack_public_path__ + "img/geburt_print.8c201c5f.jpg";